import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TaxDetailComponent } from '../tax-detail/tax-detail.component';
import { TranslateService } from '@ngx-translate/core';
import { element } from 'protractor';

@Component({
  selector: 'app-tax-report',
  templateUrl: './tax-report.component.html',
  styleUrls: ['./tax-report.component.css']
})
export class TaxReportComponent implements OnInit {

  public menu_item_id = '61';

  private dp1 = [];
  private dp2 = [];
  total_income = '0'; income_tax = '0'; income = '0';
  total_expence = '0'; expence_tax = '0'; expence = '0';

  displayedColumns1 = ['tax_name', 'sub_item_total', 'tax_total', 'total'];
  // displayedColumns2 = ['tax_name', 'sub_item_total', 'tax_total', 'total'];
  dataSource1 = new MatTableDataSource(this.dp1);
  dataSource2 = new MatTableDataSource(this.dp2);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;
  @ViewChild('TABLE') table1: ElementRef;

  model = { 'from_date': new Date(), 'to_date': new Date(), 'by_invoice': '0', 'title': 'تقرير الضرائب' };

  detailDialogRef: MatDialogRef<TaxDetailComponent>;

  Tax_Report; Incomes; Expenses; Total; From_Date; To_Date; 
  Nontaxable; Search_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Tax_Report').subscribe((res: string) => {
      this.Tax_Report = res;
    });
    this.model['title'] = this.Tax_Report;

    translate.get('Incomes').subscribe((res: string) => {
      this.Incomes = res;
    });

    translate.get('Expenses').subscribe((res: string) => {
      this.Expenses = res;
    });

    translate.get('Total').subscribe((res: string) => {
      this.Total = res;
    });

    translate.get('From_Date').subscribe((res: string) => {
      this.From_Date = res;
    });

    translate.get('To_Date').subscribe((res: string) => {
      this.To_Date = res;
    });

    translate.get('Nontaxable').subscribe((res: string) => {
      this.Nontaxable = res;
    });

    translate.get('Search_Msg').subscribe((res: string) => {
      this.Search_Msg = res;
    });
  }


  ngOnInit() {
  }

  changeRepType() {
    this.model['by_invoice'] = ((document.getElementById('by_invoice') as HTMLInputElement).checked ? '1' : '0');
  }

  search() {
    if (this.model['from_date'] == undefined || this.model['to_date'] == undefined) {
      alert(this.Search_Msg);
      return;
    }

    let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" +
      this.model['from_date'].getDate() + " 00:00:00";
    let to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" +
      this.model['to_date'].getDate() + " 23:59:59";

    this.dp1 = [];
    this.dp2 = [];

    let obj = { cmd: 'getTaxRep', from_date: from_date, to_date: to_date };

    if (this.model['by_invoice'] == '1')
      obj['by_invoice'] = this.model['by_invoice'];

    this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        console.log(data);

        this.dp1 = data.data['list'][0]['income_list'];
        this.dataSource1 = new MatTableDataSource(this.dp1);
        this.dataSource1.sort = this.sort;

        this.dp2 = data.data['list'][0]['expense_list'];
        this.dataSource2 = new MatTableDataSource(this.dp2);
        this.dataSource2.sort = this.sort;
      });

  }

  tax_detail(row) {
    if (row.acct_number != '0') {
      let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" +
        this.model['from_date'].getDate();

      let to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" +
        this.model['to_date'].getDate();

      let dialog_data = {
        'acct_number': row.acct_number,
        'tax_name_ar': row.tax_name_ar,
        'tax_name_en': row.tax_name_en,
        'from_date': from_date,
        'to_date': to_date,
        'rep_type': row.rep_type,
        'by_invoice': this.model['by_invoice']
      };

      this.detailDialogRef = this.dialog.open(TaxDetailComponent, {
        hasBackdrop: false,
        data: dialog_data,
        width: "95%",
        height: "90%"
      });
      this.detailDialogRef
        .afterClosed()
        .subscribe(result => {

        });
    }
  }

  print() {
    let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" +
      this.model['from_date'].getDate();
    let to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" +
      this.model['to_date'].getDate();

    let html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="45%"> ' + this.From_Date + ': ' + from_date + '</td><td> ' +
      this.To_Date + ': ' + to_date + '</td></tr>';
    html_data += '</table>';

    let form = (document.getElementById('form1') as HTMLFormElement);
    let table1 = (document.getElementById('rep_table3') as HTMLTableElement);
    let table2 = (document.getElementById('rep_table4') as HTMLTableElement);
    this.utils.printReport(html_data, [{ table: table1, title: this.Incomes }, 
      { table: table2, title: this.Expenses }], form, 'PDF');

  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
    this.utils.exportToExcel(this.table1.nativeElement, this.model.title);
  }

}
